import { css } from '@emotion/react';
import {
  borderRadius,
  Breakpoint,
  colorPalette,
  commonStyles,
  containerSpacing,
  containerWidth,
  fontFamily,
  fontSize,
  spacing,
} from '../../config/styles';

import { getImage } from 'gatsby-plugin-image';
import { convertToBgImage } from 'gbimage-bridge';
import BackgroundImage from 'gatsby-background-image';
import { ImageDataLike } from 'gatsby-plugin-image/dist/src/components/hooks';
import Container from '../../components/Container';
const TOP_SECTION_BOTTOM_MARGIN = '50px';
const styles = {
  section: css`
    padding-bottom: calc(${TOP_SECTION_BOTTOM_MARGIN} + ${spacing['40']});
  `,
  bgImage: css`
    padding-top: ${spacing['80']};
    min-height: 500px;
  `,
  infoBlockWrapper: css`
    position: absolute;
    right: 0;
    bottom: -${TOP_SECTION_BOTTOM_MARGIN};
    width: 100%;
    display: flex;
    justify-content: flex-end;
  `,

  infoBlockSpacer: (withBgColor: boolean) => css`
    flex-grow: 1;
    ${withBgColor &&
    css`
      background-color: ${colorPalette.lightBlue};
    `}
    ${Breakpoint.tablet} {
      display: none;
    }
  `,
  infoBlockContentWrapper: css`
    max-width: ${containerWidth};
    width: 100%;
    flex-shrink: 0;
  `,

  infoBlock: css`
    background-color: ${colorPalette.lightBlue};
    padding: ${spacing['60']};
    position: relative;
    border-top-left-radius: ${borderRadius['30']};
    border-bottom-left-radius: ${borderRadius['30']};

    ${Breakpoint.tablet} {
      margin-left: ${containerSpacing};
    }
  `,
  subtitle: css`
    font-family: ${fontFamily.elido};
    font-size: ${fontSize['30']};
    color: ${colorPalette.main};
    margin: 0;
  `,
  title: css`
    font-family: ${fontFamily.elido};
    font-size: ${fontSize['72']};
    color: ${colorPalette.main};
    margin: 0;
  `,
  text: css`
    ${commonStyles.basicText}
    font-size: ${fontSize['30']};
    padding-bottom: ${spacing['20']};
  `,
  contentSection: css`
    padding-bottom: ${spacing['60']};
  `,
  blogSectionTitle: css`
    margin: 0;
    font-family: ${fontFamily.elido};
    font-size: ${fontSize['30']};
    color: ${colorPalette.main};
    padding-bottom: ${spacing['20']};
  `,
  duration: css`
    font-family: ${fontFamily.elido};
    color: ${colorPalette.main};
    font-size: ${fontSize['24']};
    padding-bottom: ${spacing['20']};
  `,
  blockWithImage: css`
    display: flex;
    gap: ${spacing['20']};
    > div {
      flex: 1;
    }
    ${Breakpoint.mobile} {
      flex-direction: column;
    }
  `,
  textBlock: css`
    ${Breakpoint.mobile} {
      order: 2;
    }
  `,
  imageBlock: css`
    ${Breakpoint.mobile} {
      order: 0;
    }
  `,
};

export const BlogTextSection = ({ children }: { children: React.ReactNode }) => {
  return <div css={styles.text}>{children}</div>;
};

export const BlogTextTitle = ({ title }: { title: string }) => {
  return <h2 css={styles.blogSectionTitle}>{title}</h2>;
};

export const BlogSectionWithImage = ({
  contentSection,
  image,
}: {
  contentSection: React.ReactNode;
  image: React.ReactNode;
}) => {
  return (
    <div css={styles.blockWithImage}>
      <div css={styles.textBlock}>{contentSection}</div>
      <div css={styles.imageBlock}>{image}</div>
    </div>
  );
};

const BlogPage = ({
  image,
  subtitle,
  title,
  duration,
  children,
}: {
  image: ImageDataLike;
  subtitle: string;
  title: string;
  duration: string;
  children: React.ReactNode;
}) => {
  const bgImage = convertToBgImage(getImage(image));

  return (
    <>
      <section css={styles.section}>
        <BackgroundImage {...bgImage} css={styles.bgImage}>
          <div css={styles.infoBlockWrapper}>
            <div css={styles.infoBlockSpacer(false)} />
            <div css={styles.infoBlockContentWrapper}>
              <div css={styles.infoBlock}>
                <h4 css={styles.subtitle}>{subtitle}</h4>
                <h1 css={styles.title}>{title}</h1>
              </div>
            </div>
            <div css={styles.infoBlockSpacer(true)} />
          </div>
        </BackgroundImage>
      </section>
      <section css={styles.contentSection}>
        <Container>
          <section css={styles.duration}>{duration}</section>
          {children}
        </Container>
      </section>
    </>
  );
};

export default BlogPage;
